import AppAuthorAddListView from "../pages/application/create/AppAuthorAddListView";
import ConsumerCreateView from "../pages/front_office/create/ConsumerCreateView";
import SubSubMenuCreateView from "../pages/application/create/SubSubMenuCreateView";
import PageNotFoundView from "../pages/auth/PageNotFoundView";
import FrontReaderAddListView from "../pages/front_office/create/FrontReaderAddListView";
import DistrictCreateListView from "../pages/front_office/setup/DistrictCreateListView";
import FrontMargaToleCreateListView from "../pages/front_office/setup/FrontMargaToleCreateListView";
import MunicipalityCreateListView from "../pages/front_office/setup/MunicipalityCreateListView";
import ProvinceCreateListView from "../pages/front_office/setup/ProvinceCreateListView";
import TapSizeCreateListView from "../pages/front_office/setup/TapSizeCreateListView";
import FrontCasteCreateListView from "../pages/front_office/setup/FrontCasteCreateListView";
import PostalReceiveCreateListView from "../pages/application/create/PostalReceiveCreateListView";
import FrontCustomerListView from "../pages/front_office/reports/FrontCustomerListView";
import GeneralLedgerListView from "../pages/account/setup/GeneralLedgerListView";
import VoucherEntryCreateListView from "../pages/account/create/VoucherEntryCreateListView";
import SubLedgerCreateListView from "../pages/account/setup/SubLedgerCreateListView";
import AcParticularCreateListView from "../pages/account/setup/AcParticularCreateListView";
import AcFiscalYearCreateListView from "../pages/account/setup/AcFiscalYearCreateListView";
import TariffParameterCreateListView from "../pages/account/setup/TariffParameterCreateListView";
import MahasulEntryCreateListView from "../pages/account/create/MahasulEntryCreateListView";
import EMIPaymentReportListView from "../pages/front_office/reports/EMIPaymentReportListView";
import OrganizationSetupCreateListView from "../pages/application/create/OrganizationSetupCreateListView";
import CategoryMasterCreateListView from "../pages/inventory/setup/CategoryMasterCreateListView";
import ItemCategoryCreateListView from "../pages/inventory/setup/ItemCategoryCreateListView";
import UnitCreateListView from "../pages/inventory/setup/UnitCreateListView";
import ItemStoreCreateListView from "../pages/inventory/setup/ItemStoreCreateListView";
import ItemSuppilerCreateListView from "../pages/inventory/setup/ItemSuppilerCreateListView";
import InventoryProductCreateView from "../pages/inventory/create/InventoryProductCreateView";
import InventoryProductListView from "../pages/inventory/reports/InventoryProductListView";
import InventoryProductIssueCreateView from "../pages/inventory/create/InventoryProductIssueCreateView";
import ProductSalesCreateView from "../pages/inventory/create/ProductSalesCreateView";
import ProductPurchaseCreateView from "../pages/inventory/create/ProductPurchaseCreateView";
import InventoryPurchaseReportListView from "../pages/inventory/reports/InventoryPurchaseReportListView";
import InventoryIssueReturnReportListView from "../pages/inventory/reports/InventoryIssueReturnReportListView";
import InventorySalesReportListView from "../pages/inventory/reports/InventorySalesReportListView";
import InventoryStockReportListView from "../pages/inventory/reports/InventoryStockReportListView";
import PayrollStaffCreateListView from "../pages/payroll/create/PayrollStaffCreateListView";
import DesignationCreateListView from "../pages/payroll/setup/DesignationCreateListView";
import PayrollStaffListReportView from "../pages/payroll/reports/PayrollStaffListReportView";
import MainDashboardView from "../pages/MainDashboardView";
import StaffPayrollCreateListView from "../pages/payroll/create/StaffPayrollCreateListView";
import BillingEntryCreateListView from "../pages/account/create/BillingEntryCreateListView";
import ConsumerProfileCreateListView from "../pages/front_office/reports/ConsumerProfileCreateListView";
import FrontConsumerProfileDetailsView from "../pages/front_office/reports/FrontConsumerProfileDetailsView";
import TransactionReportCreateListView from "../pages/account/reports/TransactionReportCreateListView";
import TrialReportCreateListView from "../pages/account/reports/TrialReportCreateListView";
import BalanceSheetReportCreateListView from "../pages/account/reports/BalanceSheetReportCreateListView";
import ProfitAndLossReportCreateListView from "../pages/account/reports/ProfitAndLossReportCreateListView";
import VoucherReportCreateListView from "../pages/account/reports/VoucherReportCreateListView";
import AccountLedgerReportCreateListView from "../pages/account/reports/AccountLedgerReportCreateListView";
import ToleWiseUserArrangeCreateListView from "../pages/front_office/create/ToleWiseUserArrangeCreateListView";
import PostingMahasultoAccountCreatelistView from "../pages/account/create/PostingMahasultoAccountCreatelistView";
import AccountMahasulReportListView from "../pages/account/reports/AccountMahasulReportListView";
import MemberAdvancedAmountReportCreateListView from "../pages/account/reports/MemberAdvancedAmountReportCreateListView";
import MonthlyReadingReportCreateListView from "../pages/account/reports/MonthlyReadingReportCreateListView";
import DayBookReportCreateListView from "../pages/account/reports/DayBookReportCreateListView";
import AdvancedVoucherReportCreateListView from "../pages/account/reports/AdvancedVoucherReportCreateListView";
import EditCustomerEditUpdateView from "../pages/front_office/create/EditCustomerEditUpdateView";
import ManageUnitListReportView from "../pages/account/reports/ManageUnitListReportView";
import ManageUnitCorrectionView from "../pages/account/create/ManageUnitCorrectionView";

interface ComponentMap {
  [key: string]: React.ComponentType<any>;
}

const componentMap: ComponentMap = {
  ConsumerCreateView: ConsumerCreateView,
  SubSubMenuCreateView: SubSubMenuCreateView,
  AppAuthorAddListView: AppAuthorAddListView,
  DistrictCreateListView: DistrictCreateListView,
  MunicipalityCreateListView: MunicipalityCreateListView,
  ProvinceCreateListView: ProvinceCreateListView,
  FrontMargaToleCreateListView: FrontMargaToleCreateListView,
  TapSizeCreateListView: TapSizeCreateListView,
  FrontReaderAddListView: FrontReaderAddListView,
  FrontCasteCreateListView: FrontCasteCreateListView,
  PostalReceiveCreateListView: PostalReceiveCreateListView,
  FrontCustomerListView: FrontCustomerListView,
  GeneralLedgerListView: GeneralLedgerListView,
  VoucherEntryCreateListView: VoucherEntryCreateListView,
  SubLedgerCreateListView: SubLedgerCreateListView,
  AcParticularCreateListView: AcParticularCreateListView,
  AcFiscalYearCreateListView: AcFiscalYearCreateListView,
  TariffParameterCreateListView: TariffParameterCreateListView,
  MahasulEntryCreateListView: MahasulEntryCreateListView,
  EMIPaymentReportListView: EMIPaymentReportListView,
  OrganizationSetupCreateListView: OrganizationSetupCreateListView,
  CategoryMasterCreateListView: CategoryMasterCreateListView,
  ItemCategoryCreateListView: ItemCategoryCreateListView,
  UnitCreateListView: UnitCreateListView,
  ItemStoreCreateListView: ItemStoreCreateListView,
  ItemSuppilerCreateListView: ItemSuppilerCreateListView,
  InventoryProductCreateView: InventoryProductCreateView,
  InventoryProductListView: InventoryProductListView,
  InventoryProductIssueCreateView: InventoryProductIssueCreateView,
  ProductSalesCreateView: ProductSalesCreateView, 
  ProductPurchaseCreateView: ProductPurchaseCreateView,
  InventoryPurchaseReportListView: InventoryPurchaseReportListView,
  InventoryIssueReturnReportListView: InventoryIssueReturnReportListView,
  InventorySalesReportListView: InventorySalesReportListView,
  InventoryStockReportListView: InventoryStockReportListView,
  PayrollStaffCreateListView: PayrollStaffCreateListView,
  DesignationCreateListView: DesignationCreateListView,
  PayrollStaffListReportView: PayrollStaffListReportView,
  MainDashboardView: MainDashboardView,
  StaffPayrollCreateListView: StaffPayrollCreateListView,
  BillingEntryCreateListView: BillingEntryCreateListView,
  ConsumerProfileCreateListView: ConsumerProfileCreateListView,
  FrontConsumerProfileDetailsView: FrontConsumerProfileDetailsView,
  TransactionReportCreateListView: TransactionReportCreateListView,
  TrialReportCreateListView: TrialReportCreateListView,
  BalanceSheetReportCreateListView: BalanceSheetReportCreateListView,
  ProfitAndLossReportCreateListView: ProfitAndLossReportCreateListView,
  VoucherReportCreateListView: VoucherReportCreateListView,
  AccountLedgerReportCreateListView: AccountLedgerReportCreateListView,
  ToleWiseUserArrangeCreateListView:ToleWiseUserArrangeCreateListView,
  PostingMahasultoAccountCreatelistView: PostingMahasultoAccountCreatelistView,
  AccountMahasulReportListView: AccountMahasulReportListView,
  MemberAdvancedAmountReportCreateListView: MemberAdvancedAmountReportCreateListView,
  MonthlyReadingReportCreateListView: MonthlyReadingReportCreateListView,
  DayBookReportCreateListView: DayBookReportCreateListView,
  AdvancedVoucherReportCreateListView: AdvancedVoucherReportCreateListView,
  EditCustomerEditUpdateView: EditCustomerEditUpdateView,
  ManageUnitListReportView:ManageUnitListReportView,
  ManageUnitCorrectionView: ManageUnitCorrectionView
};

interface ImportComponentProps {
  route: string;
}

export const ImportComponent = ({ route }: ImportComponentProps): React.ReactElement => {
  const Component = componentMap[route] || PageNotFoundView;
  return <Component />;
};
